import { Gender } from '@hc-frontend/entities'

const getGender = gender => (gender === Gender.Male ? 'Male' : 'Female')

export default getGender
